/**
 * Generates an RB key for filter pills.
 *
 * @param {string} filterLabel - The label of the filter.
 * @param {string} tagList - The tag list name.
 */
export const getFilterPillRBKey = ({ filterLabel, tagList }) => {
  if (!filterLabel || !tagList) {
    return '';
  }

  const filter = tagList.replace(/^tag_/, '').replace(/_list$/, '');
  const filterOption = filterLabel.replace(/ |-/g, '_').toLowerCase();

  return `${filter}_${filterOption}`;
};
